module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAKCAYAAADxeBEhAAAAXElEQVRYhe3TwQ1AUBRE0feJJqy0ILqwVp2mfikiYU0U4K0lzqlgMskt4zRdQcz7WZftGD0RMaxt7fry+y8ezQc2wGcJBBICgYRAICEQSAgEEgKBhEAgIRB4ExE3x6gI7nEdEqUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/public/3color.png
// module id = x4fi
// module chunks = 0